import { SocialProvider } from '@dtx-company/true-common/src/types/socialProvider'
import { fireHeapEvent } from '../helpers'
import eventNames from '../constants/cohort'

const {
  Revenue_PlansPage_SignedUp,
  Revenue_PlansPage_CheckedOut,
  Revenue_SignupPage_Viewed_Page,
  Revenue_SignupPage_SignedUp,
  Revenue_TaggingPage_Checkedout,
  Revenue_PlansPage_Clicked_WatchPlanVideo,
  Revenue_PlansPage_Clicked_LearnMoreDropdown,
  Revenue_PlansPage_Clicked_CollapseDropdown,
  Revenue_PlansPage_Clicked_CardsArrow,
  Revenue_PlansPage_ScrolledPast_Competitors,
  Revenue_PlansPage_ScrolledPast_FeatureTable,
  Revenue_PlansPage_Clicked_LearnMore,
  Revenue_PlansPage_Viewed_o2o
} = eventNames

const e = {
  Revenue_PlansPage_SignedUp: (args: { cohort: string; variant: string | null }): void => {
    fireHeapEvent(Revenue_PlansPage_SignedUp, args)
  },
  Revenue_PlansPage_CheckedOut: (args: {
    planSelected: string
    cohort: string
    variant: string | null
  }): void => {
    fireHeapEvent(Revenue_PlansPage_CheckedOut, args)
  },
  Revenue_TaggingPage_Checkedout: (args: {
    planSelected: string
    cohort: string
    promoCode: string
  }): void => {
    fireHeapEvent(Revenue_TaggingPage_Checkedout, args)
  },
  Revenue_SignupPage_Viewed_Page: (cohort: string): void => {
    fireHeapEvent(Revenue_SignupPage_Viewed_Page, { cohort })
  },
  Revenue_SignupPage_SignedUp: (cohort: string): void => {
    fireHeapEvent(Revenue_SignupPage_SignedUp, { cohort })
  },
  Revenue_PlansPage_Clicked_WatchPlanVideo: (args: {
    label: string
    cohort: string
    is_logged_in: boolean
  }): void => {
    fireHeapEvent(Revenue_PlansPage_Clicked_WatchPlanVideo, args)
  },
  Revenue_PlansPage_Clicked_LearnMoreDropdown: (args: {
    label: string
    cohort: string
    is_logged_in: boolean
  }): void => {
    fireHeapEvent(Revenue_PlansPage_Clicked_LearnMoreDropdown, args)
  },
  Revenue_PlansPage_Clicked_CollapseDropdown: (args: {
    label: string
    cohort: string
    is_logged_in: boolean
  }): void => {
    fireHeapEvent(Revenue_PlansPage_Clicked_CollapseDropdown, args)
  },
  Revenue_PlansPage_Clicked_CardsArrow: (args: {
    type: string
    cohort: string
    is_logged_in: boolean
  }): void => {
    fireHeapEvent(Revenue_PlansPage_Clicked_CardsArrow, args)
  },
  Revenue_PlansPage_ScrolledPast_Competitors: (args: {
    cohort: string
    is_logged_in: boolean
  }): void => {
    fireHeapEvent(Revenue_PlansPage_ScrolledPast_Competitors, args)
  },
  Revenue_PlansPage_ScrolledPast_FeatureTable: (args: {
    cohort: string
    is_logged_in: boolean
  }): void => {
    fireHeapEvent(Revenue_PlansPage_ScrolledPast_FeatureTable, args)
  },
  Revenue_PlansPage_Clicked_LearnMore: (args: { cohort: string; is_logged_in: boolean }): void => {
    fireHeapEvent(Revenue_PlansPage_Clicked_LearnMore, args)
  },
  Revenue_PlansPage_Viewed_o2o: (args: {
    duration: number
    cohort: string
    variant: string
    is_logged_in: boolean
  }): void => {
    fireHeapEvent(Revenue_PlansPage_Viewed_o2o, args)
  },
  userAuthenticatedSuccessfully: (args: {
    cohort: string
    method: SocialProvider
    variant: string | null
  }): void => {
    const { userAuthenticatedSuccessfully } = eventNames
    fireHeapEvent(userAuthenticatedSuccessfully, args)
  }
}

export default e
